import createPromise from 'nq/src/createPromise'
import BaseFormPresenter from '../../base/BaseFormPresenter'
import { deleteImageUseCase, saveImageUseCase } from '../../usecases/file'
import ConfirmDialog from '../../base/ProgressDialog'
import { dialog } from '../../nq-component'
class SubscriptionFormPresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, upsertUseCase, findObjectUseCase) {
    super(view, getObjectUseCase, upsertUseCase)
    this.findObjectUseCase = findObjectUseCase
  }
//   componentDidMount() {
//     this.init()
//     this.getObject()
//   }

  

}

export default SubscriptionFormPresenter
